import React, { useEffect, useState } from "react";
import styles from "./avg-sync-time.module.css";
import { AdminPartialUser } from "@boxem/core-api-schema";
import Flex from "@/components/Flex/Flex";
import LoadingSpinner from "@/components/LoadingSpinner/LoadingSpinner";
import { formatNumberAsMinAndHours } from "@/utils/formatUtils";

type AvgSyncTimeProps = {
  users: AdminPartialUser[];
  loading: boolean;
};

const AvgSyncTime = ({
  users,
  loading,
}: AvgSyncTimeProps) => {
  const [avgSyncTime, setAvgSyncTime] = useState<string>();

  const generateStatData = () => {
    const validUsers = users.filter((u) => {
      const startTime = new Date(u.startSyncAt).getTime();
      const endTime = new Date(u.endSyncAt).getTime();
      return !isNaN(startTime) && !isNaN(endTime) && endTime >= startTime;
    });

    if (validUsers.length === 0) {
      setAvgSyncTime("0 min");
      return;
    }

    const totalMinutes = validUsers.reduce((acc, user) => {
      const startTime = new Date(user.startSyncAt).getTime();
      const endTime = new Date(user.endSyncAt).getTime();
      // diff in minutes
      const diffMinutes = (endTime - startTime) / (1000 * 60);
      return acc + diffMinutes;
    }, 0);

    const averageMinutes = totalMinutes / validUsers.length;
    const formattedTime = formatNumberAsMinAndHours(averageMinutes);

    setAvgSyncTime(formattedTime);
  };

  useEffect(() => {
    if (!loading && !!users) generateStatData();
  }, [users, loading]);

  return (
    <Flex
      justify="center"
      align="center"
      direction="column"
      className={styles.statContainer}
    >
      {(loading) ? <LoadingSpinner size="3rem" /> : (
        <>
          <h1 className={`${styles.statHeader} strong`}>{avgSyncTime}</h1>
          <h3 className={`${styles.statSubHeader} strong`}>Avg Sync Time</h3>
        </>
      )}
    </Flex>
  );
};

export default AvgSyncTime;